import { render, staticRenderFns } from "./ImgsView.vue?vue&type=template&id=4916aba2&"
import script from "./ImgsView.vue?vue&type=script&lang=js&"
export * from "./ImgsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports